import { render, staticRenderFns } from "./DialogCampaign.vue?vue&type=template&id=fb352902"
import script from "./DialogCampaign.vue?vue&type=script&lang=js"
export * from "./DialogCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports